export default __webpack_public_path__ + "static/media/gigadeflatonftmHLP.13267bd5.png";